import { createInputTokens } from '../tokens/components.js';
import { type SemanticTokens, SEMANTIC } from '../tokens/semantic.js';

/**
 * Inputtext Component Configuration
 */
export function createInputtext(s: SemanticTokens) {
  const inputTokens = createInputTokens(s);
  return {
  root: {
    background: inputTokens.bg,
    disabledBackground: inputTokens.bgDisabled,
    filledBackground: inputTokens.bg,
    filledHoverBackground: inputTokens.bgHover,
    filledFocusBackground: inputTokens.bg,
    borderColor: inputTokens.border,
    hoverBorderColor: inputTokens.border,
    focusBorderColor: inputTokens.borderFocus,
    invalidBorderColor: inputTokens.borderInvalid,
    color: inputTokens.fg,
    disabledColor: inputTokens.fgDisabled,
    placeholderColor: inputTokens.placeholder,
    invalidPlaceholderColor: inputTokens.placeholder,
    shadow: 'none',
    paddingX: inputTokens.base.paddingX,
    paddingY: inputTokens.base.paddingY,
    borderRadius: inputTokens.base.radius,
    focusRing: { width: '0', style: 'none', color: 'transparent', offset: '0', shadow: 'none' },
    transitionDuration: inputTokens.base.transition,
  },
  colorScheme: {
    light: {
      root: {
        background: inputTokens.bg,
        disabledBackground: inputTokens.bgDisabled,
        filledBackground: inputTokens.bg,
        filledHoverBackground: inputTokens.bgHover,
        filledFocusBackground: inputTokens.bg,
        borderColor: inputTokens.border,
        hoverBorderColor: inputTokens.border,
        focusBorderColor: inputTokens.borderFocus,
        invalidBorderColor: inputTokens.borderInvalid,
        color: inputTokens.fg,
        disabledColor: inputTokens.fgDisabled,
        placeholderColor: inputTokens.placeholder,
        invalidPlaceholderColor: inputTokens.placeholder,
      },
    },
  },
  css: () => `
      /* Normalize line-height to match p-multiselect (avoids 58px vs 56px discrepancy
         caused by inheriting body line-height: 1.5 from Tailwind) */
      .p-inputtext {
        line-height: normal;
      }

      /* Disabled placeholder color */
      .p-inputtext:disabled::placeholder {
        color: ${inputTokens.fgDisabled};
      }

      /* Disabled icon color in p-iconfield */
      .p-iconfield:has(.p-inputtext:disabled) .p-inputicon {
        color: ${inputTokens.fgDisabled};
      }
    `,
  };
}
export const inputtext = createInputtext(SEMANTIC);